import { CometChat } from "@cometchat/chat-sdk-javascript";
import {
  CometChatCalls
} from "@cometchat/calls-sdk-javascript";
import { authApi } from "./lib/api";

const appId = "1672495643e33f363";
const region = "IN";
const authKey = "7c4ef31874eb7a36f26b1035672674db294eb378";

export async function initCometChat() {

   // -------------------------
  // Initialize CALLS SDK (REQUIRED)
  // -------------------------
  const callsAppSettings = new CometChatCalls.CallAppSettingsBuilder()
  .setAppId(appId)
  .setRegion(region)
  .build();
  await CometChatCalls.init(callsAppSettings);


  const appSetting = new CometChat.AppSettingsBuilder()
    .subscribePresenceForAllUsers()
    .setRegion(region)
    .autoEstablishSocketConnection(true)
    .setStorageMode(CometChat.StorageMode.SESSION)
    .build();

  return CometChat.init(appId, appSetting);
}

export async function loginUser(uid: string) {
  return CometChat.login(uid, authKey);
}

export async function createUser(uid: string, name: string) {
  const user = new CometChat.User(uid);
  user.setName(name);
  console.log("In createUser -",name, uid)

  const response = await authApi.createCometchatUser(uid, name);
  return response;
  
}

export { CometChat };
